import request from '../utils/request';
import config from '../config/app-config';

const wxz = config.wxzDomain;

/**
 * 店铺售卖品牌系列车型
 */
// eslint-disable-next-line import/prefer-default-export
export const getSaleCarsList = () => request.post({ url: wxz.concat('/api/api/autohome/saleCars') });
/**
 * 获取车型颜色
 */
export const getCarColor = (data) => request.postJson({ url: wxz.concat('/api/api/autohome/carColor'), data });
/**
 * 获取汽车之家客户资料信息
 */
export const getCustomer = (data) => request.postJson({ url: wxz.concat('/api/api/autohome/getCustomerInfo'), data });
/**
 * 查询地区信息
 */
export const getAreaInfo = (data) => request.postJson({ url: wxz.concat('/api/api/autohome/areaInfo'), data });

/**
 * 保存
 */
export const AddCustomer = (data) => request.post({ url: wxz.concat('/api/api/autohome/saveCustomerInfo'), data });
